// FILECONTENT_START src/common/modules/theme/ThemeModeSwitcher.tsx
import { useDispatch, useSelector } from "react-redux";
import { Switch, SwitchProps } from "../../components/Inputs";
import { selectThemeMode, setThemeMode } from "./themeSlice";

export interface ThemeModeSwitcherProps
  extends Omit<SwitchProps, "onChange" | "value"> {}

export default function ThemeModeSwitcher(props: ThemeModeSwitcherProps) {
  const dispatch = useDispatch();
  const themeMode = useSelector(selectThemeMode);

  function handleThemeModeChange(event: any) {
    dispatch(setThemeMode(event.target.value ? "dark" : "light"));
  }

  return (
    <Switch
      value={themeMode === "dark"}
      onChange={handleThemeModeChange}
      {...props}
    />
  );
}

// FILECONTENT_END src/common/modules/theme/ThemeModeSwitcher.tsx